import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ text }) {
  const items = (text || "MAXIMIZE REWARD POINTS • TRAVEL BETTER • UNLOCK LUXURY • SPEND SMARTER")
    .split("•")
    .map((t) => t.trim())
    .filter(Boolean);
  return (
    <div className="my-4 border-y border-white/10 py-4">
      <Marquee speed={26} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-6 flex items-center gap-6">
            <span className="text-xl font-bold uppercase tracking-[0.1em] text-white/85">{t}</span>
            <span className="text-[var(--accent)]">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
